import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49bcb42e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Locations-container" }
const _hoisted_2 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_3 = { class: "col text-wrap text-truncate" }
const _hoisted_4 = { class: "col-auto ms-auto align-self-end align-self-sm-start" }
const _hoisted_5 = { class: "mt-sm-0 d-flex col-sm-auto mt-2 col-12 col-sm-auto" }
const _hoisted_6 = {
  key: 0,
  class: "mx-sm-2"
}
const _hoisted_7 = {
  key: 1,
  class: "ms-auto"
}
const _hoisted_8 = {
  key: 2,
  class: "ms-sm-2 ms-auto"
}
const _hoisted_9 = { class: "dt-container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add a sublocation to your location. Example: Third floor, Building A", -1))
const _hoisted_15 = { class: "inventory-table__actions d-flex flex-column flex-md-row justify-content-md-between" }
const _hoisted_16 = { class: "d-flex flex-column flex-md-row mb-2" }
const _hoisted_17 = {
  key: 0,
  class: "me-md-2 mb-2 mb-md-0"
}
const _hoisted_18 = { class: "align-self-md-center" }
const _hoisted_19 = {
  key: 1,
  class: "row"
}
const _hoisted_20 = { class: "col-sm-12" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add or remove rooms from this location.", -1))
const _hoisted_22 = { class: "inventory-table__actions d-flex flex-column flex-md-row justify-content-md-between" }
const _hoisted_23 = { class: "mt-2 align-self-md-center" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  class: "icon icon--color",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = ["d"]
const _hoisted_27 = {
  key: 2,
  class: "row"
}
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = {
  id: "map",
  class: "map"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Click on the map and move your mouse to begin drawing a line. Click again to end that line and begin drawing a second line. Continue until you've drawn a complete, closed shape. You can hold Shift while drawing to switch to free drawing. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_MapContainer = _resolveComponent("MapContainer")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ModelSelector = _resolveComponent("ModelSelector")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/locations" }, {
          default: _withCtx(() => [
            _createTextVNode("Locations")
          ]),
          _: 1
        }),
        _createTextVNode(" » "),
        _createVNode(_component_router_link, {
          to: `/locations/${ _ctx.location.parentLocation ? _ctx.location.parentLocation.id : _ctx.location.id }`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.location.parentLocation ? _ctx.location.parentLocation.name : _ctx.location.name), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.location.parentLocation && _ctx.location.parentLocation.id)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" » "),
              _createVNode(_component_router_link, {
                to: `/locations/${_ctx.location.id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.location.name), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _ctx.onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.creationMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                disabled: _ctx.saving,
                type: "danger",
                onClick: _ctx.onDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Delete " + _toDisplayString(_ctx.locationOrSublocation(true)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.creationMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                disabled: _ctx.saving,
                type: "primary",
                onClick: _ctx.onSave
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save " + _toDisplayString(_ctx.locationOrSublocation(true)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                disabled: _ctx.saving,
                type: "primary",
                onClick: _ctx.onCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Create " + _toDisplayString(_ctx.locationOrSublocation(true)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_form, {
        "hide-required-asterisk": "",
        ref: "form",
        "label-position": "top",
        rules: _ctx.rules,
        model: _ctx.location,
        onSubmit: _withModifiers(_ctx.onEnter, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form_item, {
                label: "Location Name",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, "Enter a " + _toDisplayString(_ctx.locationOrSublocation(false)) + " name. Example: Headquarters", 1),
                  _createVNode(_component_el_input, {
                    placeholder: "Location Name",
                    modelValue: _ctx.location.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.location.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          (!_ctx.creationMode && !_ctx.location.parentLocation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_form_item, { label: "Sublocations" }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (!_ctx.creationMode && _ctx.childLocations)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_el_button, {
                                  disabled: _ctx.saving,
                                  type: "danger",
                                  onClick: _ctx.onRemoveSublocations
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Delete Sublocation(s) ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            (!_ctx.creationMode)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  disabled: _ctx.saving,
                                  type: "primary",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (
												_ctx.$router.push({
													path: `/locations/new/${_ctx.location.id}`,
												})
											))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.childLocations ? "Add Sublocation" : "Add First Sublocation"), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          (_ctx.childLocations)
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 0,
                                placeholder: "Search Sublocations",
                                modelValue: _ctx.locationSearchInput,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.locationSearchInput) = $event))
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                        data: _ctx.processedChildLocations || [],
                        ref: "sublocationTable",
                        style: {"width":"100%"},
                        "default-sort": {prop: 'name', order: 'ascending'},
                        onCellClick: _ctx.handleSublocationClick,
                        onSelectionChange: _ctx.handleSublocationSelectionChange,
                        onSortChange: _ctx.handleSublocationSortChange
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            type: "selection",
                            width: "55"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "name",
                            label: "Name",
                            sortable: ""
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_router_link, {
                                to: `/locations/${scope.row.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "roomCount",
                            label: "Rooms",
                            sortable: ""
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "deviceCount",
                            label: "Receivers",
                            sortable: ""
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "onCellClick", "onSelectionChange", "onSortChange"])), [
                        [_directive_loading, _ctx.sublocationTableLoading]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.creationMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_form_item, { label: "Rooms" }, {
                    default: _withCtx(() => [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_button, {
                            disabled: _ctx.saving || _ctx.manageRoomsLoading,
                            type: "primary",
                            onClick: _ctx.activateRoomManagementSelector
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Manage Rooms ")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          (_ctx.locationRooms)
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 0,
                                placeholder: "Search Rooms",
                                modelValue: _ctx.roomSearchInput,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.roomSearchInput) = $event))
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                        data: _ctx.locationRooms || [],
                        ref: "multipleTable",
                        style: {"width":"100%"},
                        onCellClick: _ctx.handleRoomClick,
                        onSortChange: _ctx.sortTable
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "roomName",
                            label: "Name",
                            sortable: "custom"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_router_link, {
                                to: `/rooms/${scope.row.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.roomName), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "roomCode",
                            label: "Room Code",
                            sortable: "custom"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "devices",
                            label: "Active",
                            sortable: "custom"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.devices && scope.row.devices.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                    _createTextVNode(" Yes "),
                                    (_openBlock(), _createElementBlock("svg", _hoisted_25, [
                                      _createElementVNode("path", { d: _ctx.mdiCheckBold }, null, 8, _hoisted_26)
                                    ]))
                                  ]))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    disabled: _ctx.saving,
                                    type: "primary",
                                    plain: "",
                                    round: "",
                                    onClick: _withModifiers(_ctx.addReceiverLink, ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Add Receiver ")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "onClick"]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "location.name",
                            label: "Location",
                            sortable: "custom"
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "onCellClick", "onSortChange"])), [
                        [_directive_loading, _ctx.roomTableLoading]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isEmergencyAlertsEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.locationOrSublocation(true) + ' Area'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, " Click on the map to draw a shape to define this " + _toDisplayString(_ctx.locationOrSublocation(false)) + " on the map. Ditto uses this area to target Emergency Alerts that contain GPS or other location-targeting criteria. ", 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_MapContainer, {
                          alertPolygon: _ctx.location.alertPolygon,
                          onAlertPolygonChange: _ctx.changeAlertPolygon,
                          ref: "mapContainer"
                        }, null, 8, ["alertPolygon", "onAlertPolygonChange"])
                      ]),
                      _hoisted_30
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rules", "model", "onSubmit"])
    ]),
    _createVNode(_component_ModelSelector, {
      title: "Add Rooms to Location",
      subTitle: _ctx.location.name,
      modelTypeName: "rooms",
      loading: _ctx.manageRoomsLoading,
      onSelectionPoolChange: _ctx.roomSelectionChanged,
      ref: "modelSelector"
    }, null, 8, ["subTitle", "loading", "onSelectionPoolChange"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}